export const dataHeader = [
  {
    name: "Torre medica",
    color: "#782A9F",
    gradient:
      "linear-gradient(160deg, rgba(120,42,159,.07) 3%, rgba(120,42,159,.40) 100%)",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/LogoTorreMedica.svg",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Puertas_Consultorios.png",
    backgroundPosition: {
      xs: "center",
      sm: "78% center",
      md: "100% 60%",
      lg: "100% 60%",
      xl: "center 100%",
    },
  },
  {
    name: "Hospitalización",
    color: "#489E4D",
    gradient:
      "linear-gradient(160deg, rgba(72,158,77,.07) 7%, rgba(72,158,77,.40) 100%)",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/LogoHospitalizacion.svg",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion_principal_medam.png",
    backgroundPosition: {
      xs: "center",
      sm: "78% center",
      md: "100% 60%",
      lg: "100% 60%",
      xl: "center 100%",
    },
  },
  {
    name: "Urgencias",
    color: "#D32D2D",
    gradient:
      "linear-gradient(160deg, rgba(211,45,45,.14) 0%, rgba(211,45,45,.30) 100%)",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/LogoUrgencias.svg",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/CentralRecuperacion.png",
    backgroundPosition: {
      xs: "center",
      sm: "78% center",
      md: "100% 60%",
      lg: "100% 60%",
      xl: "78% 100%",
    },
  },
  {
    name: "Laboratorio Clínico",
    color: "#215DA6",
    gradient:
      "linear-gradient(160deg, rgba(33,93,166,.15) 0%, rgba(33,93,166,.30) 100%)",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/LogoLaboratorio.svg",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/RenderLaboratorio.png",
    backgroundPosition: {
      xs: "center",
      sm: "78% center",
      md: "100% 60%",
      lg: "100% 60%",
      xl: "center 100%",
    },
  },
  {
    name: "Farmacia",
    color: "#D9784A",
    gradient:
      "linear-gradient(160deg, rgba(217,120,74,.10) 0%, rgba(217,120,74,.50) 100%)",
    logo: "https://centromedicomedam.com/IMG/centromedicoMEDAM/LogoFarmaciaPeach.svg",
    image: "https://centromedicomedam.com/IMG/centromedicoMEDAM/FarmaciaY.png",
    backgroundPosition: {
      xs: "center",
      sm: "78% center",
      md: "100% 60%",
      lg: "100% 60%",
      xl: "center 100%",
    },
  },
];

export const torreMedica = [
  {
    title: "Medicina General",
    description:
      "En MEDAM, la medicina general es el primer paso para cuidar tu salud. Nuestros médicos están capacitados para atender padecimientos comunes, dar orientación preventiva y guiarte hacia el tratamiento adecuado. Estamos aquí para escucharte, resolver tus dudas y acompañarte en cada etapa.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/MecinaGenera_Servicios.png",
    color: "#782A9F",
    backgroundPosition: "center 50%",
  },
  {
    title: "Pediatría",
    description:
      "El bienestar de tus hijos es nuestra prioridad. Nuestros pediatras brindan atención especializada desde el nacimiento hasta la adolescencia, con calidez, experiencia y enfoque integral. Cuidamos la salud de los más pequeños como si fueran parte de nuestra familia.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Pedriatria_Servicios.png",
    color: "#C56D43",
    backgroundPosition: "center 25%",
  },
  {
    title: "Ginecología",
    description:
      "Acompañamos a la mujer en cada etapa de su vida. Nuestro equipo de ginecología brinda atención integral en salud femenina: desde chequeos preventivos hasta tratamientos especializados, siempre con empatía, respeto y profesionalismo.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Ginecologia_Servicios.png",
    color: "#B94F83",
    backgroundPosition: "center 10%",
  },
  {
    title: "Ortopedia",
    description:
      "Diagnosticamos y tratamos lesiones, fracturas y afecciones del sistema músculo-esquelético con precisión y cuidado. En MEDAM, nuestros especialistas en ortopedia te ofrecen soluciones efectivas para recuperar tu bienestar físico.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Ortopedia_Servicios.png",
    color: "#2878B8",
    backgroundPosition: "center 10%",
  },
  {
    title: "Neurología",
    description:
      "Entendemos la importancia de un sistema nervioso sano para tu calidad de vida. Nuestros especialistas en neurología te ofrecen una atención integral, precisa y cercana, enfocada en cuidar tu salud cerebral y neurológica con profesionalismo y empatía",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Neurologia_Servicios.png",
    color: "#5B55A6",
    backgroundPosition: "center 40%",
  },
  {
    title: "Medicina Interna",
    description:
      "En MEDAM, nuestros médicos internistas te ofrecen una visión integral de tu salud. Evaluamos de forma completa tu estado general para detectar, prevenir y tratar diversas condiciones, siempre con atención cercana, profesional y personalizada.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/MecinaGenera_Servicios.png",
    color: "#277865",
    backgroundPosition: "center 5%",
  },
  {
    title: "Cardiología",
    description:
      "El corazón no solo late, también siente. Por eso, en MEDAM te ofrecemos una atención cardiológica integral, con tecnología, experiencia y el trato cálido que necesitas para cuidar lo más vital. ",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Cardiologia_Servicios.png",
    color: "#B84455",
    backgroundPosition: "center 40%",
  },
];

export const dataHospitalizacion = [
  {
    title: "Cirugía General",
    description:
      "Nuestro servicio de cirugía general hospitalaria en MEDAM está respaldado por quirófanos equipados con tecnología de última generación y un equipo médico altamente capacitado. Desde el preoperatorio hasta tu recuperación, cuidamos cada detalle para ofrecerte procedimientos seguros, eficaces y con un trato humano que genera confianza.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/MecinaGenera_Servicios.png",
    color: "#782A9F",
    backgroundPosition: "center 50%",
  },
  {
    title: "Pediatría",
    description:
      "Los más pequeños reciben atención médica en espacios adaptados especialmente para ellos. Contamos con habitaciones pediátricas diseñadas para ofrecer un entorno cómodo y seguro, así como un equipo de especialistas que brinda cuidados hospitalarios con empatía, experiencia y cercanía hacia las familias.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Pedriatria_Servicios.png",
    color: "#C56D43",
    backgroundPosition: "center 25%",
  },
  {
    title: "Gineco-Obstetricia",
    description:
      "Las pacientes ginecológicas y obstétricas cuentan con un piso exclusivo diseñado para brindar privacidad, confort y atención especializada. Nuestro equipo médico y de enfermería está enfocado en acompañarte con calidez en cada etapa del tratamiento o recuperación, en un entorno pensado especialmente para ti.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Ginecologia_Servicios.png",
    color: "#B94F83",
    backgroundPosition: "center 10%",
  },
  {
    title: "Traumatología",
    description:
      "En casos que requieren hospitalización por lesiones, fracturas o cirugías ortopédicas, nuestro equipo de traumatología te acompaña con un enfoque profesional y resolutivo. En MEDAM contamos con infraestructura especializada para tu recuperación y atención médica continua centrada en devolverte tu movilidad y bienestar.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Ortopedia_Servicios.png",
    color: "#2878B8",
    backgroundPosition: "center 10%",
  },
  {
    title: "Neurología",
    description:
      "Brindamos atención neurológica especializada dentro del entorno hospitalario para pacientes que requieren estudios, monitoreo o tratamientos complejos. Contamos con infraestructura de apoyo diagnóstico y un equipo médico capacitado para acompañarte en cada etapa, con precisión clínica y un trato humano que prioriza tu bienestar.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Neurologia_Servicios.png",
    color: "#277865",
    backgroundPosition: "center 40%",
  },
  {
    title: "Urología",
    description:
      "El servicio de urología hospitalaria ofrece procedimientos quirúrgicos y tratamientos que requieren internamiento en un entorno seguro y moderno. Nuestros especialistas cuidan de tu salud urológica con profesionalismo, discreción y la infraestructura necesaria para garantizar tu tranquilidad.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/MecinaGenera_Servicios.png",
    color: "#5B55A6",
    backgroundPosition: "center 100%",
  },
  {
    title: "Cardiología",
    description:
      "Nuestra unidad de cardiología hospitalaria está preparada para atender desde valoraciones especializadas hasta eventos que requieren cuidados inmediatos. Combinamos monitoreo avanzado, tecnología de punta y un equipo de cardiólogos que trabaja contigo para estabilizar, tratar y proteger tu salud cardiovascular con excelencia y empatía.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Cardiologia_Servicios.png",
    color: "#B84455",
    backgroundPosition: "center 40%",
  },
];

export const dataFarmacia = {
  id: 1,
  tag: "SERVICIOS",
  title: "Farmacia",
  color: "#D9784A", // Verde principal
  bgColor: "#d9774a1e", // Verde muy claro
  circleColor: "#d9774a5a", // Círculo decorativo
  paragraphs: [
    <>
      En la farmacia de <strong>MEDAM</strong>, tu salud es nuestra prioridad.
      Contamos con un <strong>amplio surtido de medicamentos</strong>, insumos y
      productos esenciales, seleccionados para acompañarte en cada etapa de tu
      tratamiento.
    </>,
    <>
      Gracias a un equipo <strong>capacitado</strong> y procesos eficientes, te
      garantizamos un servicio ágil, confiable y siempre cercano.
    </>,
  ],
  highlight: (
    <>
      Además, nuestras farmacias están integradas al modelo de atención médica
      de <strong>MEDAM</strong>, lo que permite una mayor coordinación con los
      especialistas que te atienden.
    </>
  ),
  footer: (
    <>
      Aquí encontrarás{" "}
      <strong>todo lo que necesitas para cuidar de ti y de los tuyos.</strong>
    </>
  ),
  badgeTitle: "COMPROMISO",
  badgeText: "Calidad y confianza en cada medicamento.",
  image: null,
  // "https://centromedicomedam.com/IMG/centromedicoMEDAM/Farmacia_detalles_del_centro-medico_MEDAM.png",
};

export const dataUrgencias = {
  id: 2,
  tag: "SERVICIOS",
  title: "Urgencias",
  color: "#D32D2D",
  bgColor: "#FDECEC",
  circleColor: "#F8D8D8",
  paragraphs: [
    <>
      En <strong>MEDAM</strong>, estamos listos para actuar cuando más se
      necesita.
    </>,
    <>
      Nuestra <strong>área de urgencias</strong> opera las
      <strong> 24 horas del día, los 365 días del año</strong>, con un equipo de
      médicos urgenciólogos y personal capacitado preparado para atender
      cualquier tipo de emergencia con rapidez, seguridad y precisión.
    </>,
    <>
      Contamos con un <strong>cuarto de choque totalmente equipado</strong>,
      acceso inmediato a pruebas diagnósticas y entrada directa desde el
      estacionamiento para brindar una atención más rápida y eficiente.
    </>,
  ],
  highlight: (
    <>
      Nuestro personal está preparado para responder con rapidez,
      profesionalismo y tecnología de vanguardia en cada emergencia.
    </>
  ),
  footer: (
    <>
      Porque <strong>tu vida y tu tranquilidad no pueden esperar.</strong>
    </>
  ),
  badgeTitle: "24/7",
  badgeText: "Atención inmediata las 24 horas.",
  image:
    "https://centromedicomedam.com/IMG/centromedicoMEDAM/Urgencias_del_centro-medico_MEDAM.jpg",
};
